/* eslint-disable */
/*
 * This was automatically generated by frontend/onboarding/onboarding.ts.
 * DO NOT MANUALLY EDIT
 * Please refer to https://wistia.github.io/wistia/main/?path=/docs/onboarding-docs-getting-started--docs for more information.
 */

export const activeOnboarding = {
  audioDescriptionOrders: {
    id: 'audioDescriptionOrders-b8255e0f-4793-4969-9711-1f64de33dfd3',
    pillar: 'publish',
    product: 'customize'
  },
  'storybook-preview-hotspot': {
    id: 'storybook-preview-hotspot-4b1733d9-7f6c-448a-be7a-125e6dd6f3c4',
    pillar: 'growth',
    product: 'onboarding'
  },
  passwordChannelsShare: {
    id: 'passwordChannelsShare-ee36a26f-3331-49e8-8aff-e0b8f93e2ef6',
    pillar: 'publish',
    product: 'channel-page'
  },
  passwordChannelsCustomize: {
    id: 'passwordChannelsCustomize-e48084c4-7242-4a1d-967a-08bdb84ff2b3',
    pillar: 'publish',
    product: 'channel-page'
  },
  redesignMediaPage: {
    id: 'redesignMediaPage-5fc54044-975b-459b-bc15-59df3d941df9',
    pillar: 'organize',
    product: 'discover'
  },
  editorRescript: {
    id: 'editorRescript-d9884234-f479-4630-9809-ca17da808fdc',
    pillar: 'create',
    product: 'edit'
  },
  webinarsInChannels: {
    id: 'webinarsInChannels-7cdce1d9-22eb-48db-9464-41fb17d6c84d',
    pillar: 'publish',
    product: 'live'
  },
  redesignChannelManage: {
    id: 'redesignChannelManage-d96f43fe-e18e-4913-a05d-613ecd2e52d4',
    pillar: 'publish',
    product: 'channel-page'
  },
  videoBumper: {
    id: 'videoBumper-6f6309c0-162b-4efd-a9ca-de0ba209ae72',
    pillar: 'growth',
    product: 'onboarding'
  },
  liveOverviewCustomizeRecording: {
    id: 'liveOverviewCustomizeRecording-80fc41c9-cabf-4b49-8d6a-3ac016141bec',
    pillar: 'create',
    product: 'live'
  },
  newRegPageLayout: {
    id: 'newRegPageLayout-881d1472-453d-463b-8e0c-ea0999c49507',
    pillar: 'create',
    product: 'live'
  },
  subjectDetection: {
    id: 'subjectDetection-4a6a8fbb-8d75-49d5-a85a-e17c41eff396',
    pillar: 'create',
    product: 'edit'
  }
};

export const SUPPORTED_FEATURE_IDS = [
  'audioDescriptionOrders',
  'storybook-preview-hotspot',
  'passwordChannelsShare',
  'passwordChannelsCustomize',
  'redesignMediaPage',
  'editorRescript',
  'webinarsInChannels',
  'redesignChannelManage',
  'videoBumper',
  'liveOverviewCustomizeRecording',
  'newRegPageLayout',
  'subjectDetection'
] as const
